<template>
    <el-container class="main-container">
        <el-main style="padding: 30px;margin: 0 auto;">
            <div style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 15px;">
                <span style="font-size: 17px;font-weight: 600;">联通大数据智慧任务</span>
                <div>
                    <span style="font-size: 15px;">正式剩余次数:{{ remainingCount.formal }}</span>
                    <span style="font-size: 15px;">测试剩余次数:{{ remainingCount.test }}</span>
                </div>
                <div>
                    <el-button
                        style="margin-right: 20px; width: 110px;border-radius:4px;background: #0079ab;color: #fff;font-size: 14px;"
                        @click="pdfDialog = true">查看说明文档</el-button>
                    <el-button class="add" @click="settings(null)">新建围栏任务</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table class="maintable" :data="tableData"
                :header-cell-style="{ background: '#87CEEB', color: '#606959', textAlign: 'center' }">
                <el-table-column label="任务id" align="center" prop="id"></el-table-column>
                <el-table-column label="任务名称" align="center" prop="task_name"></el-table-column>
                <el-table-column label="城市名" align="center" prop="city_name"></el-table-column>
                <el-table-column label="创建者" align="center" prop="author"></el-table-column>
                <el-table-column label="城市月份" align="center" prop="citymonth"></el-table-column>
                <el-table-column label="围栏文件名" align="center" prop="uploadfile" width="300"></el-table-column>
                <el-table-column label="状态" align="center" prop="status">
                    <template #default="scope">
                        {{ scope.row.status == '0' ? '待审核' : scope.row.status == '1' ? '审核通过' : scope.row.status == '2' ?
                            '审核不通过' : scope.row.status == '3' ? '执行中' : scope.row.status == '4' ? '成功' : '已终止'
                        }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="330" prop="status">
                    <template #default="scope">
                        <div style="cursor: pointer;font-size: 15px;margin-bottom:2px;" v-if="scope.row.status == 4">
                            <!-- <i class="el-icon-bianji" style="margin:0px 10px;" @click="viewCharts(scope.row.id)">查看详情</i> | -->
                            <i class="el-icon-download" style="margin:0px 10px;"
                                @click="downloadCSV(scope.row.csvfile)">下载资源</i>
                        </div>
                        <div style="cursor: pointer;font-size: 15px;margin-bottom:2px;" v-if="scope.row.status == 4">
                            <i class="el-icon-map-location" style="margin:0px 10px;" @click="check(scope.row)">查看地图详情</i>
                        </div>
                        <div style="cursor: pointer;font-size: 15px;" v-if="scope.row.status == 4">
                            <i class="el-icon-s-data" style="margin:0px 10px;" @click="viewTable(scope.row.id)">查看数据详情</i>
                        </div>
                        <div style="cursor: pointer;font-size: 15px;" v-else-if="scope.row.status == 0">
                            <i class="el-icon-delete" style="margin:0px 10px;" @click="deleteProject(scope.row.id)">删除任务</i>
                        </div>
                        <div style="cursor: pointer;font-size: 15px;" v-else>-</div>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog title="新建任务" :visible.sync="projectDialog" width="600px" @close="closeProjectDialog">
                <el-form :model="projectSetting" ref="projectSetting" :rules="submitRules" label-width="120px"
                    label-position="right" v-loading="uploadLoading">
                    <el-form-item prop="name" label="任务名称">
                        <el-input v-model="projectSetting.name" placeholder="请输入任务名称"></el-input>
                    </el-form-item>
                    <el-form-item prop="city" label="城市" required>
                        <el-input v-model="projectSetting.city" placeholder="请输入城市名称"></el-input>
                    </el-form-item>
                    <el-form-item prop="time" label="数据时间">
                        <el-date-picker type="month" placeholder="选择日期" :picker-options="pickerOptions"
                            :default-value="yearValue" value-format="yyyyMM" v-model="projectSetting.time"
                            @change="timeChange" @focus="focusYear" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="clean" label="围栏文件">
                        <el-input v-model="projectSetting.clean" :readonly="true" style="width: 300px;"><i slot="suffix"
                                v-if="projectSetting.clean" class="el-icon-delete" style="color:red;font-size: 20px;"
                                @click="deleteFile"></i>
                        </el-input>
                        <el-upload style="margin-left: 10px; width: 70px;display: inline-block;" ref="upload" action=""
                            name="files" :limit="1" :auto-upload="false" :show-file-list="false" :on-change="fileChange"
                            :on-exceed="limitAlert" accept=".csv">
                            <el-button>上传</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align: center;">
                    <el-button @click="saveProject">提交审核</el-button>
                    <el-button @click="projectDialog = false">取消</el-button>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="pdfDialog" title="智慧足迹接口调用说明文档" width="80%">
                <iframe :src="pdfUrl" frameborder="0" width="100%" height="800px">
                    您的浏览器不支持 iframe 标签。
                </iframe>
            </el-dialog>

        </el-main>
    </el-container>
</template>
<script>
import { getdatas, deletedatas, getdatanums } from '../../api/unicomData'
import { Message } from 'element-ui';
export default {
    components: {},
    data() {
        return {
            resultId: 0,
            pdfDialog: false,
            pdfUrl: '../static/智慧足迹接口调用说明文档4.1.pdf',
            projectDialog: false,
            uploadLoading: false,
            currentType: 0,
            cityArr: [],
            provinceArr: [],
            projectSetting: {
                id: '',
                name: '',
                city: '',
                time: '',
                province: '',
                origin: '',
                clean: '',
                province_id: '',
                city_id: '',
                file: ''
            },
            // 表格数据
            tableData: [],
            value: '',
            // 搜索名
            kw: '',
            // 状态筛选
            status: '',
            // 分享弹框
            shareForm: {
                sharePsd: '',
                shareLink: '',
                shareIndate1: '',
                shareIndate2: '',
            },
            shareId: '',
            // 新建组件
            newTaskVisible: false,
            // 设置组件
            addVisible: false,
            // 任务详情
            missionInfo: {},
            // 任务数据
            // missionData:[],
            // 分享弹框
            shareVisible: false,
            generalData: {
                cityName: '',
                wlName: '',
                sjzId: null
            },
            shareCreator: '',
            editPwd: '',
            currentCity: '',
            rules: {
                sharePsd: [
                    { required: true, message: '请输入项目', trigger: 'blur' },
                ],
                shareIndate1: [
                    { required: true, message: '请选择省市名', trigger: 'change' }
                ],
            },
            submitRules: {
                name: [
                    { required: true, message: '请输入任务名称', trigger: 'blur' }
                ],
                city: [
                    { required: true, message: '请输入城市名称', trigger: 'blur' }
                ],
                clean: [
                    { required: true, message: '请上传围栏文件', trigger: 'blur' }
                ],
                time: [
                    { required: true, message: '请选择时间月份', trigger: 'change' }
                ]
            },
            remainingCount: {
                formal: 0,
                test: 0
            },
            yearValue: '',
            pickerOptions: {
                disabledDate(time) {
                    const today = new Date();
                    const currentYear = today.getFullYear();
                    const currentDay = today.getDate();
                    const currentMonth = today.getMonth();

                    let allowedDates = [];
                    let allowedYears = [];
                    // 如果当前月份是1月，允许上一年的年份和这年的年份
                    if (currentMonth === 0) {
                        allowedYears = [currentYear - 1];
                    } else {
                        if (currentMonth === 1) {
                            if (currentDay >= 25) {
                                allowedYears = [currentYear - 1, currentYear];
                            }
                            else {
                                allowedYears = [currentYear - 1];
                            }
                        }
                        else if (currentMonth === 2) {
                            if (currentDay >= 25) {
                                allowedYears = [currentYear];
                            }
                            else {
                                allowedYears = [currentYear - 1, currentYear];
                            }
                        }
                        else {
                            allowedYears = [currentYear];
                        }
                    }
                    // 如果不是允许的年份，则禁用日期
                    if (!allowedYears.includes(time.getFullYear())) {
                        return true;
                    }
                    // 计算允许的月份
                    if (currentDay >= 25) {
                        // 如果当前日期是25号或之后，查看前两个月，可能包括前一年的最后一个月
                        allowedDates = [
                            { month: (currentMonth + 10) % 12, year: (currentMonth + 10) % 12 < currentMonth ? currentYear : currentYear - 1 },
                            { month: (currentMonth + 11) % 12, year: (currentMonth + 11) % 12 < currentMonth ? currentYear : currentYear - 1 }
                        ];
                    } else {
                        // 如果当前日期是25号之前，查看前两个月，可能包括前一年的最后一个月
                        allowedDates = [
                            { month: (currentMonth + 9) % 12, year: (currentMonth + 9) % 12 < currentMonth ? currentYear : currentYear - 1 },
                            { month: (currentMonth + 10) % 12, year: (currentMonth + 10) % 12 < currentMonth ? currentYear : currentYear - 1 }
                        ];
                    }
                    // 判断选中的日期是否在允许的年份和月份内
                    return !allowedDates.some(allowed => {
                        return time.getFullYear() === allowed.year && time.getMonth() === allowed.month;
                    });
                }
            }
        }
    },
    mounted() {
    },
    methods: {
        drawerClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        viewTable(id) {
            this.resultId = id
            this.$router.push({ path: '/unicomData/viewTable', query: { data: this.resultId } })
        },
        check(item) {
            console.log(item);
            // this.$router.push('/unicomData/unicomMap' + item.id)
            this.$router.push({ path: '/unicomData/unicomMap', query: { id: item.id } })
        },
        focusYear() {
            const today = new Date();
            const currentYear = today.getFullYear();
            const currentMonth = today.getMonth();
            if (currentMonth === 0 || currentMonth === 1) {
                this.yearValue = [currentYear - 1];
            }
            else {
                this.yearValue = [currentYear];
            }
        },
        viewCharts(id) {
            this.$router.push({ path: '', query: { id: id } })
        },
        //终止项目
        stopCalculation(id) {
            cancel({ project_id: id }).then(res => {
                if (res.errno === 0) {
                    this.$message.success(res.error)
                    this.getProject()
                }
                else {
                    this.$message.error(res.error)
                }
            })
        },
        deleteProject(id) {
            deletedatas({ token: localStorage.getItem('token'), id: id }).then(res => {
                if (res.errno === 0) {
                    this.$message.success('删除任务成功')
                    this.getProject()
                }
                else {
                    this.$message.error(res.error)
                }
            })
        },
        // 获取项目列表
        getProject() {
            let params = {
                token: localStorage.getItem('token'),
                page: '',
                page_size: ''
            }
            getdatas(params).then(res => {
                this.tableData = res.data.data
            })
            getdatanums({ token: localStorage.getItem('token') }).then(res => {
                if (res.errno === 0) {
                    this.remainingCount.formal = res.data.zs_sy
                    this.remainingCount.test = res.data.test_sy
                }
            })
        },
        // 编辑按钮
        edit(row) {
            // 存入store中
            this.$store.commit('getMission', row)
            // 跳转到城市地图页面
            const url = this.$router.resolve({
                path: '/cityhome'
            })
            window.open(url.href, '_blank')
            //this.$router.push({name:'城市地图'})
        },

        // 关闭设置弹框
        handleClose(val) {
            this.addVisible = val
            this.generalData = {}
        },
        // 关闭新建弹框
        newTaskClose(val) {
            this.newTaskVisible = false
        },
        closeProjectDialog() {
            this.$refs.projectSetting.resetFields()
            this.currentType = 0
        },
        deleteFile() {
            this.$refs.upload.clearFiles()
            this.projectSetting.clean = ''
        },
        limitAlert(files) {
            this.$message.error('请删除已上传文件再上传')
        },
        fileChange(info) {
            if (info.status == 'ready') {
                this.projectSetting.file = info.raw
                this.projectSetting.clean = info.name
            }
        },
        timeChange(time) {
            this.projectSetting.time = time
        },
        saveProject() {
            this.$refs['projectSetting'].validate((valid) => {
                if (valid) {
                    let paramsData = new FormData();
                    paramsData.append('token', localStorage.getItem('token'))
                    paramsData.append('task_name', this.projectSetting.name)
                    paramsData.append('city_name', this.projectSetting.city)
                    paramsData.append('author', localStorage.getItem('name'))
                    paramsData.append('citymonth', this.projectSetting.time)
                    paramsData.append('batchFile', this.projectSetting.file)
                    fetch('/api/admin/adddatas', {
                        method: 'POST',
                        body: paramsData, // FormData对象
                        headers: {
                            'Custom-Header': 'multipart/form-data'
                        }
                    }).then(res => {
                        if (res.status === 200) {
                            this.projectDialog = false
                            this.$refs.upload.clearFiles()
                            this.getProject()
                        }
                        else {
                            this.$refs.upload.clearFiles()
                            this.projectSetting.clean = ''
                            Message.warning('上传失败,请重试!')
                        }
                    });
                } else {
                    return false;
                }
            })
        },
        downloadCSV(link) {
            if (link && link != null) {
                window.open(link, '_blank')
            }
            else {
                Message.warning('请稍等片刻，系统正在生成资源中!')
            }
        },
        selectProvince(item) {
            this.projectSetting.province_id = item
            let obj = this.provinceArr.find(para => {
                return item === para.id
            })
            this.projectSetting.province = obj.area_name
            citys({ province_id: this.projectSetting.province_id }).then(res => {
                this.cityArr = res.data
                this.projectSetting.city = this.cityArr[0].area_name
                this.projectSetting.city_id = this.cityArr[0].id
            })
        },
        selectCity(item) {
            this.projectSetting.city_id = item
            let obj = this.cityArr.find(para => {
                return item === para.id
            })
            this.projectSetting.city = obj.area_name
        },
        // 设置
        async settings(id) {
            this.projectDialog = true
        },
        // 删除按钮
        handleDel(id) {
            this.$confirm('此操作将永久删除该任务, 是否继续?', '提示', { type: 'warning' }).then(() => {
                missionDel({ mission_id: id }).then(res => {
                    if (res.errno == 0) {
                        Message.success('删除成功')
                        this.getProject()
                    }
                    else {
                        Message.error(res.error)
                    }
                }).catch((error) => {
                    Message.error(error)
                })
            }).catch(() => {
                Message.error('已取消删除')
            })
        },
        // 关闭分享弹窗
        shareClose() {
            this.shareVisible = false

            this.shareForm.shareLink = ''
            this.shareForm.sharePsd = ''
            this.shareForm.shareIndate1 = ''
            this.shareForm.shareIndate2 = ''
            this.editPwd = ''
            this.$refs['shareForm'].clearValidate();
        },
        // 分享弹框确认按钮
        shareSubmit() {
            let data = {
                mission_id: this.shareId,
                pwd: this.shareForm.sharePsd,
                url: this.shareForm.shareLink,
                yxq_start: this.shareForm.shareIndate1,
                yxq_end: this.shareForm.shareIndate2
            }
            this.$refs['shareForm'].validate((valid) => {
                if (valid) {
                    createMissionShare(data).then(res => {
                        if (res.errno != 0) {
                            Message.error(res.error)
                        }
                        else {
                            this.shareVisible = false
                            Message.success(res.error)
                        }
                        this.shareForm.shareLink = ''
                        this.shareForm.sharePsd = ''
                        this.shareForm.shareIndate1 = ''
                        this.shareForm.shareIndate2 = ''
                        this.editPwd = ''
                    })
                } else {
                    Message.error('请填写完整')
                    return false;
                }
            })
        },
        copyLink() {
            const link = document.getElementById('sharelink')
            link.select()
            document.execCommand("Copy");
            this.$message({
                message: '分享链接复制成功!',
                type: 'success'
            });
        }
    },
    computed: {
        userData() {
            return this.$store.state.userData
        },
        token() {
            return this.$store.state.token
        }
    },
    watch: {
        editPwd: function (ov) {
            this.shareForm.shareLink = window.location.origin + '/#/cityHome?id=' + this.shareId + '&city=' + this.currentCity + '&pwd=' + this.editPwd
            this.shareForm.sharePsd = this.editPwd
        }
    },
    created() {
        document.title = '任务首页';
        // 获取任务列表
        this.getProject()
    }
}
</script>
  
<style scoped>
.main-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}

.maintable {
    width: 100%;
}

.from {
    display: flex;
    justify-content: start;
    align-items: center;
    margin-bottom: 30px;
}

.input {
    width: 320px;
    /* // height: 32px; */
    border-radius: 6px;
    margin-right: 35px;
    background: #fff;
    /* // border: 1px solid rgba(96, 105, 89, 0.3); */
}

/deep/.el-select {
    width: 166px;
    /* // height: 32px; */
    border-radius: 6px;
    background: #fff;
    border: 1px solid rgba(96, 105, 89, 0.25);
}

.state {
    color: #606959;
    margin-right: 5px;
}

.submit {
    margin-left: 8px;
    width: 80px;
    /* // height: 30px; */
    border-radius: 4px;
    background: #8ba07b;
    text-align: center;
    color: #fff;
}

.add {
    width: 171px;
    /* // height: 30px; */
    border-radius: 4px;
    background: #87CEEB;
    text-align: center;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
}

/* .dialog-footer {
    text-align: center;

    button {
        background-color: #8aa07b;
        color: #fff;
        width: 120px;
        text-align: center;
    }
} */
</style>


// WEBPACK FOOTER //
// src/views/unicomData/fenceUpload.vue